"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayLegalUserDocumentType = void 0;
var MangopayLegalUserDocumentType;
(function (MangopayLegalUserDocumentType) {
    MangopayLegalUserDocumentType["IDENTITY_PROOF"] = "IDENTITY_PROOF";
    MangopayLegalUserDocumentType["ARTICLES_OF_ASSOCIATION"] = "ARTICLES_OF_ASSOCIATION";
    MangopayLegalUserDocumentType["REGISTRATION_PROOF"] = "REGISTRATION_PROOF";
    MangopayLegalUserDocumentType["SHAREHOLDER_DECLARATION"] = "SHAREHOLDER_DECLARATION";
})(MangopayLegalUserDocumentType || (exports.MangopayLegalUserDocumentType = MangopayLegalUserDocumentType = {}));
//# sourceMappingURL=MangopayLegalUserDocumentType.js.map